import { useApiClient } from '@react/lib/api';
import { useInfiniteQuery } from 'react-query';

export function useReportsQuery({
  searchTerm,
  filters
}: {
  searchTerm: string;
  filters: any;
}) {
  const apiClient = useApiClient().resolve;

  return useInfiniteQuery(
    ['superAdminReports', { searchTerm, filters }],
    ({ pageParam }: { pageParam?: number }) =>
      apiClient.getReports({
        page: pageParam,
        query: searchTerm,
        filters
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (lastPage.data.length === 0) {
          return undefined;
        }
        return pages.length + 1;
      }
    }
  );
}
